import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMark32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconQuestionMark32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.97 10.243c.214-.857.633-1.67 1.27-2.258C13.863 7.412 14.743 7 16 7c1.273 0 2.256.42 2.918 1.082S20 9.727 20 11c0 1.263-.884 2.22-2.207 3.543l-.107.107C16.52 15.813 15 17.33 15 19.5a1 1 0 1 0 2 0c0-1.263.884-2.22 2.207-3.543l.107-.107C20.48 14.687 22 13.17 22 11c0-1.727-.58-3.244-1.668-4.332S17.727 5 16 5c-1.742 0-3.112.588-4.116 1.515-.987.911-1.568 2.1-1.854 3.242a1 1 0 0 0 1.94.486M16 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMark32);
